/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import '../../../css/admin_layout.css';

/* 관리자로그인 */
const LoginAdmin = () => {
  const navigate = useNavigate();
  const refPwd = useRef(null);
  const refLogin = useRef(null);
  
  //아이디/패스워드 
  const [varID, setID] = useState("");
  const [varPassword, setPassword] = useState("");

  //로그인을 위한 이메일주소와 암호 입력받기
  const ChangeIDHandler = (e) => {
    setID(e.currentTarget.value);
  };
  const onPasswordHanlder = (e) => {
    setPassword(e.currentTarget.value);
  };

  //키보드
  const onKeyPressHandler = (e,ino) => {
    if (e.key === 'Enter') {
      if(ino === 0) {
        refPwd.current.focus();
      } else {
        refLogin.current.click();
      }
    }
  }

  //관리자 로그인 
  const loginProgressingHandler = async(e) => {
    const sendData = {admin_id:varID,admin_pwd:varPassword};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_login_admin`, sendData).then((res) => {
      console.log( res.data);
      if (res.data.retvalue === 1) {
        const datas = res.data.results;
        localStorage.setItem("adminLoginState", 1);               //로그인상태
        localStorage.setItem("adminIdx", datas.adm_idx);          //회원번호
        localStorage.setItem("adminName", datas.adm_name);        //회원명
        localStorage.setItem("adminMode", datas.adm_mode);        //1:관리자/2:부운영자
        //메뉴사용권한
        localStorage.setItem("menuAvailables", datas.adm_available);
        navigate("/MainAdmin");
      } else {
        alert(res.data.message);
      }
    });
  };

  return (
    <div className="admin-login-wrap-box">
      <div className="admin-login-wrap">
        <p style={{marginBottom:"20px"}}>마마몽떼 관리시스템</p>
        <b>관리자로그인</b>
        <span>
          사이트 관리자 페이지로 접속하기 위한 로그인 페이지입니다.
          <br />
          아이디와 비밀번호를 입력하여 주시기기 바랍니다.
        </span>
        <div className="login-form-box">
          <input type="text" value={varID} placeholder="관리자 아이디를 입력하세요" onKeyPress={e=>onKeyPressHandler(e,0)} onChange={(e)=>ChangeIDHandler(e)} />
          <input type="password" ref={refPwd} value={varPassword} placeholder="관리자 비밀번호를 입력하세요" onKeyPress={e=>onKeyPressHandler(e,1)} onChange={(e)=>onPasswordHanlder(e)} className="ml-none" />
          <input type="button" ref={refLogin} value="로그인" style={{paddingTop:"0px"}} onClick={(e)=>loginProgressingHandler(e)} />
        </div>
      </div>
    </div>
  );
}

export default LoginAdmin;
